import {CacheState} from "./CacheState";
import {ProgramAndStatuses} from "../../model/program/ProgramAndStatuses";

export class ProgramAndStatusesState implements CacheState {
    constructor(public programAndStatusesMap: Map<number, ProgramAndStatuses> = new Map<number, ProgramAndStatuses>(),
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {
    }
}